module.exports = __webpack_public_path__ + "img/icon-drop-down-disabled.1c6949e3.svg";